import { origin } from '@web3/base-utils';
const bybitglobal_domain = 'https://www.bybitglobal.com';

/**
 * Since current locale from business in nextjs is not match HTML lang-locale standard, we do some process for compatible with standard
 * ref: https://c1ey4wdv9g.larksuite.com/wiki/wikusCtEHKf3q4qR3VAHE16tBVe
 * @param locale current locale
 * @returns format lang
 */
export const getSeoFormatLang = (locale) => {
  let formatLocale = locale;
  if (formatLocale?.toLowerCase() === 'fil-ph') {
    formatLocale = 'tl';
  }
  if (formatLocale?.toLowerCase() === 'es-419') {
    formatLocale = 'es';
  }
  return formatLocale;
};

export function genPath(locale, path, lang) {
  const _locale = lang || locale;
  let url = path.startsWith('/') ? `/${_locale}${path}` : `/${_locale}/${path}`;

  switch (_locale) {
    case 'id-ID':
      url = bybitglobal_domain + url;
      break;
    default:
      url = origin + url;
      break;
  }
  return url;
}
